import { registerPlugin } from "@wordpress/plugins";
import { PluginPostStatusInfo } from "@wordpress/editor";
import { useSelect, useDispatch } from "@wordpress/data";
import { PanelColorSettings } from "@wordpress/block-editor";
import React, { useState, useEffect } from "react";

const PostColorSelector = () => {
    const { meta } = useSelect(
        (select) => ({
            meta: select("core/editor").getEditedPostAttribute("meta") || {},
        }),
        []
    );

    const { editPost } = useDispatch("core/editor");
    const [imageUrl, setImageUrl] = useState(meta.featured_image_url || "");

    // Synchronizuj stan z meta
    useEffect(() => {
        setImageUrl(meta.featured_image_url || "");
    }, [meta.featured_image_url]);

    const updateColors = (value, key) => {
        editPost({
            meta: {
                ...meta,
                [key]: value || "",
            },
        });
    };

    const updateImageUrl = (url) => {
        setImageUrl(url);
        editPost({
            meta: {
                ...meta,
                featured_image_url: url || "",
            },
        });
    };

    return (
        <PluginPostStatusInfo className="custom-color-settings-wrapper">
            <PanelColorSettings
                title="Color Settings"
                colorSettings={[
                    {
                        value: meta.color_menu || "#000",
                        label: "Menu Color",
                        onChange: (value) => updateColors(value, "color_menu"),
                    },
                    {
                        value: meta.footer_color_background || "#e6ebef",
                        label: "Footer Background Color",
                        onChange: (value) =>
                            updateColors(value, "footer_color_background"),
                    },
                ]}
                disableCustomColors={false}
                enableAlpha={true}
            />
            <div className="featured-image-url-setting">
                <label htmlFor="featured-image-url">Featured Image URL</label>
                <input
                    type="url"
                    id="featured-image-url"
                    value={imageUrl}
                    onChange={(e) => updateImageUrl(e.target.value)}
                    placeholder="Enter image URL..."
                    style={{
                        width: "100%",
                        marginTop: "8px",
                        padding: "6px 8px",
                    }}
                />
            </div>
        </PluginPostStatusInfo>
    );
};

registerPlugin("post-color-plugin", {
    render: PostColorSelector,
    icon: "admin-appearance",
});
